"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var _getDependencies = _interopRequireDefault(require("./getDependencies"));
var snakeToTitle = _modalLoaderUtils.HELPERS.snakeToTitle;
var _default = exports.default = function _default(_ref) {
  var namespace = _ref.namespace;
  var loadedDeps = (0, _getDependencies.default)(namespace);
  var packageName = snakeToTitle(namespace);
  var component = loadedDeps[packageName];
  return component ? component.default : null;
};